"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _isBrowser = _interopRequireDefault(require("./isBrowser"));

var isCurrentPathname = function isCurrentPathname() {
  for (var _len = arguments.length, pathnames = new Array(_len), _key = 0; _key < _len; _key++) {
    pathnames[_key] = arguments[_key];
  }

  return pathnames.some(function (pathname) {
    return (0, _isBrowser.default)() && pathname === window.location.pathname;
  });
};

var _default = isCurrentPathname;
exports.default = _default;